export enum BildirimKategoriEnum {
  'BK-01' = 'Suç Gelirlerinin Aklanması',
  'BK-02' = 'Terörizmin Finansmanı',
  'BK-03' = 'Kitle İmha Silahlarının Yayılmasının Finansmanı',
}

export enum AciliyetEnum {
  'A-01' = 'Normal',
  'A-02' = 'İvedi',
  'A-03' = 'Çok İvedi',
  'A-04' = 'İşlemin Ertelenmesi Talepli',
}

export enum TerorOrgutuEnum {
  'TO-01' = 'Bölücü Terör Örgütleri',
  'TO-02' = 'Dini İstismar Eden Terör Örgütleri',
  'TO-03' = 'Aşırı Sol Terör Örgütleri',
}

export enum GercekKisiIslemBaglantisiEnum {
  'GB-01' = 'Kendisi Adına İşlem Yapan',
  'GB-02' = 'Başkası Adına İşlem Yapan',
  'GB-03' = 'Adına İşlem Yapılan',
  'GB-04' = 'Gerçek Faydalanıcı',
  'GB-05' = 'Dolaylı Olarak İlgili',
}

export enum CinsiyetEnum {
  'K' = 'Kadın',
  'E' = 'Erkek',
  'B' = 'Bilinmiyor',
}

export enum BelgeTuruEnum {
  'KT-01' = 'Nüfus Cüzdanı',
  'KT-02' = 'T.C. Kimlik Kartı',
  'KT-03' = 'Yeni Tip Sürücü Belgesi',
  'KT-04' = 'Pasaport',
  'KT-05' = 'İkamet İzin Belgesi',
  'KT-06' = 'Sürücü Belgesi',
  'KT-99' = 'Diğer Belge',
}

export enum MeslekEnum {
  'M-01' = 'Antikacı',
  'M-02' = 'Asker',
  'M-03' = 'Avukat',
  'M-04' = 'Bahçıvan',
  'M-05' = 'Bakkal/Market/Kasap/Manav',
  'M-06' = 'Balıkçı',
  'M-07' = 'Bankacı',
  'M-08' = 'Bilinmiyor',
  'M-09' = 'Çaycı',
  'M-10' = 'Çiçekçi',
  'M-11' = 'Çiftçi/Besici/Ormancı',
  'M-12' = 'Boyacı/Elektrikçi/Demirci/Tesisatçı/Marangoz',
  'M-13' = 'Aşçı/Garson/Barmen',
  'M-14' = 'Diş Hekimi',
  'M-15' = 'Doktor',
  'M-16' = 'Eczacı',
  'M-17' = 'Emlakçı',
  'M-18' = 'Esnaf/Zanaatkar',
  'M-19' = 'Ev Hanımı',
  'M-20' = 'Galerici',
  'M-21' = 'Gazeteci',
  'M-22' = 'Hemşire/Ebe',
  'M-23' = 'Hizmetli',
  'M-24' = 'İmalatçı',
  'M-25' = 'İnşaatçı',
  'M-26' = 'İşçi',
  'M-27' = 'İşsiz',
  'M-28' = 'Kaportacı',
  'M-29' = 'Komisyoncu',
  'M-30' = 'Konfeksiyoncu',
  'M-31' = 'Kurye',
  'M-32' = 'Kuyumcu/Sarraf',
  'M-33' = 'Memur',
  'M-34' = 'Milletvekili',
  'M-35' = 'Mimar/İç Mimar',
  'M-36' = 'Muhasebeci',
  'M-37' = 'Mühendis',
  'M-38' = 'Müşavir',
  'M-39' = 'Mütercim/Tercüman/Çevirmen',
  'M-40' = 'Nakliyeci',
  'M-41' = 'Öğrenci',
  'M-42' = 'Öğretmen/Eğitmen',
  'M-43' = 'Pilot/Kaptan',
  'M-44' = 'Polis/Jandarma/Güvenlik Görevlisi',
  'M-45' = 'Psikolog',
  'M-46' = 'Sanatçı',
  'M-47' = 'Sekreter/Yönetici Asistanı',
  'M-48' = 'Serbest Meslek',
  'M-49' = 'Sigortacı',
  'M-50' = 'Sporcu/Antrenör/Hakem',
  'M-51' = 'Şoför',
  'M-52' = 'Tahsildar',
  'M-53' = 'Tamirci',
  'M-54' = 'Teknisyen',
  'M-55' = 'Temizlikçi',
  'M-56' = 'Terzi',
  'M-57' = 'Tüccar',
  'M-58' = 'Veteriner',
  'M-59' = 'Emekli',
  'M-60' = 'Biyolog',
  'M-61' = 'Borsacı/Finansçı/Ekonomist',
  'M-62' = 'Din Görevlisi',
  'M-63' = 'Diyetisyen',
  'M-64' = 'Fizyoterapist',
  'M-65' = 'Hakim/Savcı',
  'M-66' = 'Hostes',
  'M-67' = 'Kamu Görevlisi',
  'M-68' = 'Noter',
  'M-69' = 'Öğretim Görevlisi/Akademisyen',
  'M-70' = 'Programcı/Yazılımcı/Analist',
  'M-71' = 'Tasarımcı (Grafik, Moda, Sanat, Reklam vs)',
  'M-72' = 'Berber/Kuaför/Güzellik Uzmanı',
  'M-73' = 'Dealer/Broker',
  'M-74' = 'Danışman',
  'M-75' = 'Diplomat/Hariciyeci',
  'M-76' = 'Distribütör',
  'M-77' = 'Fotoğrafçı',
  'M-78' = 'İşletmeci (Kafe/Otel/Restoran/Eğlence)',
  'M-79' = 'Manken/Fotomodel',
  'M-80' = 'Müteahhit',
  'M-81' = 'Muhtar',
  'M-82' = 'Rehber/Tur Operatörü',
  'M-83' = 'Pazarlamacı',
  'M-84' = 'Satış Görevlisi/Tezgahtar',
  'M-85' = 'Reklamcı',
  'M-86' = 'Gemi Kaptanı',
  'M-87' = 'Sağlık Personeli',
  'M-88' = 'Vali',
  'M-89' = 'Kaymakam',
  'M-90' = 'Bürokrat',
  'M-91' = 'Üst Düzey Yönetici (Genel Müdür, Genel Müdür Yard., CEO, vb.)',
  'M-92' = 'Yerel Yönetici (Belediye Başkanı vb.)',
  'M-93' = 'PEP',
  'M-94' = 'Firma Ortağı/Sahibi',
  'M-999' = 'Diğer',
}

export enum AdresEnum {
  'diger' = 'Diğer Adres',
  'ev' = 'Ev Adresi',
  'is' = 'İş Adresi',
  'merkez' = 'Merkez Adresi',
  'sube' = 'Şube Adresi',
}

export enum IletisimEnum {
  'is' = 'İş Telefonu',
  'faks' = 'Fax',
  'ev' = 'Ev Telefonu',
  'eposta' = 'Eposta',
  'diger' = 'Diğer',
  'cep' = 'Cep Telefonu',
}

export enum KimlikTespitTuruEnum {
  'KTT-01' = 'Basitleştirilmiş Tedbirler',
  'KTT-02' = 'Tedbirler Yönetmeliği',
  'KTT-03' = 'Uzaktan Kimlik Tespiti',
  'KTT-04' = 'Müşteri Değil/Anonim Hesap oluştu',
}

export enum DigerKisiIslemBaglantisiEnum {
  'DB-01' = 'Adına İşlem Yapılan',
  'DB-02' = 'Dolaylı Olarak İlgili',
}

export enum KurulusNeviEnum {
  'KN-01' = 'Ticaret Siciline Kayıtlı Tüzel Kişiler',
  'KN-02' = 'Yurt Dışında Yerleşik Tüzel Kişiler',
  'KN-03' = 'Tüzel Kişiliği Olmayan Teşekküller',
  'KN-04' = 'Yurt Dışında Kurulmuş Güven Sözleşmeleri',
  'KN-05' = 'Dernek',
  'KN-06' = 'Vakıf',
  'KN-07' = 'Siyasi Parti',
  'KN-08' = 'Sendika/Federasyon/Konfederasyon',
}

export enum IslemCesidiEnum {
  'C-01' = 'Tek İşlem',
  'C-02' = 'Çoklu İşlem',
}

export enum IslemDurumuEnum {
  'D-01' = 'Gerçekleştirilmiş',
  'D-02' = 'Teşebbüs Aşamasında',
}

export enum ParaBirimiEnum {
  ADP = 'Andora Peseta',
  AED = 'Birleşik Arap Emirlikleri Drahmi',
  AFA = 'Afgani (AFN ile Değiştirildi) Eski',
  AFN = 'Afganistan Afganı',
  ALF = 'Altın Gram (0.999)',
  ALK = 'Lek Eski Arnavutluk',
  ALL = 'Arnavutluk Lek',
  AMD = 'Ermeni Dram',
  ANG = 'Hollanda Antiller Guikder',
  AOA = 'Angola Kwanza',
  AON = 'Angola Yenikwanza (AOA ile Değiştirildi)',
  ARP = 'Arjantin Peso (ARS ile Değiştirildi)',
  ARS = 'Arjantin Pezosu',
  ATS = 'Avusturya Şilin',
  AUD = 'Avustralya Dolar',
  AWG = 'Aruba Guilder',
  AZM = 'Azerbaycan Manat (AZN ile Değiştirildi)',
  AZN = 'Azerbaycan Manat',
  BAM = 'Bosna-Hersek Mark',
  BBD = 'Barbados Dolar',
  BDT = 'Bangladeş Taka',
  BEC = 'Belçika Frank (Convertible)',
  BEF = 'Belçika Frank',
  BEL = 'Belçika Frank (Financial)',
  BGJ = 'Bulgar Lev A/52 (BGN ile Değiştirildi)',
  BGK = 'Bulgar Lev A/62 (BGN ile Değiştirildi)',
  BGL = 'Bulgar Lev A/99 (BGN ile Değiştirildi)',
  BGN = 'Bulgar Lev',
  BHD = 'Bahreyn Dinar',
  BIF = 'Burundi Frank',
  BMD = 'Bermuda Doları',
  BND = 'Brunei Dolar',
  BOB = 'Boliviano',
  BOP = 'Bolivya Peso (BOB ile Değiştirildi)',
  BOV = 'Bolivya Mvdol',
  BRB = 'Brezilya Cruzero (BRL ile Değiştirildi)',
  BRC = 'Brezilya Cruzado (BRL ile Değiştirildi)',
  BRL = 'Brazilya Real',
  BSD = 'Bahama Dolar',
  BWP = 'Bostwana Pula',
  BYN = 'Belarus Ruble',
  BZD = 'Belize Doları',
  CAD = 'Kanada Dolar',
  CDF = 'Kongo Frank',
  CDZ = 'Zaire (CDF ile Değiştirildi)',
  CHF = 'İsviçre Frank',
  CLP = 'Şili Pezo',
  CNH = 'Çin Offshore Yuan',
  CNX = 'Çin Halk Bankası Doları (CNY ile Değiştirildi)',
  CNY = 'Çin Yuan',
  COP = 'Kolombiya Pezo',
  CRC = 'Kosta Rika Kolon',
  CSD = 'Eski Sırbistan Dinarı',
  CSJ = 'Çekoslavak Koruna A/53',
  CSK = 'Çekoslavak Koruna (CZK ve SKK ile Değiştirildi)',
  CUP = 'Küba Pezo',
  CVE = 'Cape Verde Escudo',
  CYP = 'Kıbrıs Pound',
  CYR = 'Çeyrek Altın',
  CZK = 'Çek Koruna',
  DDM = 'Doğu Almanya Mark (DEM ile Değiştirildi)',
  DEM = 'Alman Mark',
  DJF = 'Jibuti Frank',
  DKK = 'Danimarka Kron',
  DOP = 'Dominik Pezo',
  DZD = 'Cezayir Dinar',
  ECS = 'Ekvator Sucre (USD İle Değiştirildi)',
  EEK = 'Estonya Kron',
  EGP = 'Mısır Pound',
  ERN = 'Eritre Nafka',
  ESA = 'İspanyol Pezeta (Account A)',
  ESB = 'İspanyol Pezeta (Account B)',
  ESP = 'İspanyol Peseta',
  ETB = 'Etiyopya Bırr',
  EUR = 'Euro',
  FIM = 'Fin Maraka',
  FJD = 'Fijidolar',
  FKP = 'Fakland Adaları Pound',
  FRF = 'Fransız Frank',
  GBP = 'İngiliz Sterlini',
  GEL = 'Gürcü Lari',
  GHC = 'Gana Cedi',
  GIP = 'Giraltar Pound',
  GMD = 'Gambia Dalasi',
  GNF = 'Gine Frank',
  GRD = 'Yunan Drahmi',
  GTQ = 'Guatemala Quetzal',
  GWP = 'Gine-Bissau Frank',
  GYD = 'Guyana Doları',
  HKD = 'Hong Hong Dolar',
  HNL = 'Honduras Lempira',
  HRK = 'Hırvat Kuna',
  HUF = 'Macar Forint',
  IDR = 'Endonezya Rupiah',
  IEP = 'İrlanda Pound',
  ILP = 'İsrail Pound (ILR İle Değiştirildi)',
  ILR = 'İsrail Eski Şekel (ILS ile Değiştirildi)',
  ILS = 'İsrail Şekel',
  INR = 'Hindistan Rupe',
  IQD = 'Irak Dinar',
  IRR = 'İran Riyal',
  ISJ = 'İzlanda EskiRona (ISK ile Değiştirildi)',
  ISK = 'İzlanda Kron',
  ITL = 'İtalyan Liret',
  JMD = 'Jamaika Dolar',
  JOD = 'Ürdün Dinar',
  JPY = 'Japon Yen',
  KES = 'Kenya Şilin',
  KGS = 'Kırgız Som',
  KHR = 'Kamboçya Riel',
  KMF = 'Comoro Frank',
  KPW = 'Kuzey Kore Won',
  KRW = 'Güney Kore Won',
  KWD = 'Kuveyt Dinar',
  KYD = 'Cayman Adaları Dolar',
  KZT = 'Kazakistan Tenge',
  LAK = 'Lao Halk Cumh. Kip',
  LBP = 'Lübnan Pound',
  LKR = 'Srilanka Rupe',
  LRD = 'Liberya Dolar',
  LTL = 'Litvanya Litas',
  LUF = 'Luxemburg Frank',
  LYD = 'Libya Dinar',
  MAD = 'Fas Dirahmi',
  MDL = 'Moldova Leu',
  MGA = 'Madagaskar Ariari',
  MKD = 'Makedonya Dinar',
  MKN = 'Makedonya Dinar A/93 (MKD ile Değiştirildi)',
  MNT = 'Moğolistan Tugrik',
  MRO = 'Moritanya Ou',
  MTL = 'Malta Lira',
  MUR = 'Maritus Rupes',
  MVQ = 'Maldive Ruppe (MVR ile Değiştirildi)',
  MVR = 'Maldivler Rufiya',
  MWK = 'Malawikwaça',
  MXN = 'Meksika Pezos',
  MXP = 'Meksika Peso (MXN ile Değiştirildi)',
  MYR = 'Malezya Ringit',
  MZN = 'Mozambik Metical',
  NGN = 'Nijerya Naira',
  NIO = 'Nikaragua Oro',
  NLG = 'Hollanda Florini',
  NOK = 'Norveç Kron',
  NPR = 'Nepal Rupe',
  NZD = 'Yeni Zelanda Doları',
  OMR = 'Umman Riyal',
  PEH = 'Peru Sol (PEN ile Değiştirildi)',
  PEN = 'Peru Sol',
  PGK = 'Papua Yenigine Kina',
  PHP = 'Filipinler Pezo',
  PKR = 'Pakistan Rupe',
  PLN = 'Polonya Zlot',
  PLZ = 'Polonya Zloty A/94 (PLN ile Değiştirildi)',
  PTE = 'Portekiz Eskudo',
  PYG = 'Paraguay Guarani',
  QAR = 'Katar Riyal',
  ROK = 'Romanya LEU A/52 (ROL ile Değiştirildi)',
  ROL = 'Romanya LEU A/05 (RON ile Değiştirildi)',
  RON = 'Romen Yenilev',
  RSD = 'Sırbistan Dinarı',
  RUB = 'Rusya Ruble',
  RUR = 'Rusya Ruble (RUB ile Değiştirildi)',
  RWF = 'Ruanda Frank',
  SAR = 'Suudi Arabistan Riyal',
  SBD = 'Solomon Adaları Dolar',
  SCR = 'Şeysel Rupe',
  SDD = 'Sudan Dinar',
  SEK = 'İsveç Kronu',
  SGD = 'Singapur Dolar',
  SHP = 'Sen Helen Pound',
  SIT = 'Slovenya Tolar',
  SKK = 'Slovak Koruna',
  SLE = 'Siera Leone',
  SOS = 'Somali Şilin',
  SRD = 'Surinam Dolar',
  SRG = 'Surinam Guilder (SRD ile Değiştirildi)',
  SUR = 'Sovyetler Birliği Ruble (RUB ile Değiştirildi)',
  SVC = 'El Salvador Kolon',
  SYP = 'Suriye Pound',
  SZL = 'Swaziland Lilangen',
  THB = 'Tayland Baht',
  TJS = 'Tacikistan Somon',
  TMM = 'Türkmenistan Manat (Eski)',
  TMT = 'Türkmenistan Manat (Yeni)',
  TND = 'Tunus Dinar',
  TOP = "Tonga Pa'anga",
  TPE = 'Timor Escudo',
  TRL = 'Türk Lira',
  TRY = 'Türk Lirası',
  TTD = 'Trinidad Tobago Dolar',
  TWD = 'Tayvan Dolar',
  TZS = 'Tanzanya Şilin',
  UAH = 'Ukrayna Hryvnia',
  UGW = 'Uganda Eski Şilin (UGX ile Değiştirildi)',
  UGX = 'Uganda Şilin',
  USD = 'ABD Doları',
  UYN = 'Uruguay Eski Peso (UYU ile Değiştirildi)',
  UYU = 'Uruguay Pezos',
  UZS = 'Özbekistan Sum',
  VED = 'Venezuella Bolivar',
  VNC = 'Vietnam Eski Dong (VND ile Değiştirildi)',
  VND = 'Vietnam Dong',
  VUV = 'Vanuatu Vatu',
  WST = 'Samoa Adaları Tala',
  XAF = 'CFA Franc',
  XAG = 'Gümüş',
  XAU = 'Altın',
  XBA = 'Bond Markets Units European',
  XBB = 'European Monetary Unit',
  XBC = 'E.U.A.-9',
  XBD = 'E.U.A.-17',
  XCD = 'Doğu Karabian Dolar',
  XDR = 'Special Drawing Rights',
  XEU = 'Avrupa Para Değişim Birimi (ECU)',
  XFO = 'Gold-Franc',
  XFU = 'UIC-Franc',
  XOF = 'CFA Franc BCEAO',
  XPD = 'Palladium',
  XPF = 'Fransız Polonezyası Frank',
  XPT = 'Platinum',
  YDD = 'Güney Yemen Dinar (YER ile Değiştirildi)',
  YER = 'Yemen Rial',
  YUD = 'Yugoslavya Dinar (CSD ile Değiştirildi)',
  YUM = 'Yugoslavya Dinarı',
  ZAR = 'Güney Afrika Rand',
  ZMW = 'Zambia Kwacha',
  ZWL = 'Zimbabwe Dolar',
}

export enum IslemTuruEnum {
  'IG-1201' = 'Para yatırma',
  'IG-1202' = 'Para çekme',
  'IG-1310' = 'Türk Lirası Transfer (Yurt içi)',
  'IG-1311' = 'Döviz Transfer (Yurt içi)',
  'IG-1410' = 'Türk Lirası Transfer (Yurt dışı)',
  'IG-1411' = 'Döviz Transfer (Yurt dışı)',
  'IG-1501' = 'Nakdi kredi',
  'IG-1502' = 'Gayrinakdi kredi',
  'IG-1503' = 'Diğer Kredi',
  'IG-1601' = 'Döviz/efektif alım satım',
  'IG-1602' = 'Arbitraj işlemleri',
  'IG-1701' = 'Fatura',
  'IG-1702' = 'Vergi',
  'IG-1703' = 'Maaş',
  'IG-1704' = 'Kira',
  'IG-1705' = 'Aidat',
  'IG-1706' = 'Sigorta',
  'IG-1707' = 'Bahis',
  'IG-1708' = 'Bağış',
  'IG-1709' = 'Burs',
  'IG-1710' = 'Bireysel Emeklilik Ödemeleri',
  'IG-1711' = 'Diğer Ödemeler',
  'IG-1801' = 'Komisyon',
  'IG-1802' = 'Faiz/kar payı',
  'IG-1803' = 'Diğer işlem ücretleri',
  'IG-1901' = 'Vadeli mevduat/KH faiz ve kar payı tahakkuku',
  'IG-1902' = 'Yatırım Fonu',
  'IG-1903' = 'Menkul Kıymet',
  'IG-1904' = 'Repo/Ters Repo',
  'IG-1905' = 'Türev',
  'IG-1906' = 'Altın',
  'IG-1907' = 'Diğer Kıymetli Madenler',
  'IG-2001' = 'POS Satış işlemleri',
  'IG-2101' = 'POS Alış işlemleri',
  'IG-2201' = 'Çek',
  'IG-2202' = 'Bono',
  'IG-2203' = 'Poliçe',
  'IG-2204' = 'Diğer Senetler',
  'IG-2301' = 'İptal, iade, düzeltme işlemleri',
  'IG-9999' = 'Diğer',
}

export enum IslemKanaliEnum {
  'KK-01' = 'Şube',
  'KK-02' = 'ATM',
  'KK-03' = 'İnternet',
  'KK-04' = 'Pos',
  'KK-05' = 'Telefon',
  'KK-06' = 'Sistem',
  'KK-07' = 'Mobil',
  'KK-08' = 'API',
  'KK-09' = 'GSM',
  'KK-10' = 'Temsilci',
  'KK-99' = 'Diğer',
}

export enum SupheninTespitEdildigiBirimEnum {
  'BR-01' = 'Uyum Birimi',
  'BR-02' = 'Genel Müdürlük',
  'BR-03' = 'Denetim Birimi',
  'BR-04' = 'Şube/Temsilci',
}

export enum HesapTuruEnum {
  'HT-01' = 'Vadesiz Mevduat / Cari Hesap',
  'HT-02' = 'Vadeli Mevduat / Katılım Hesabı',
  'HT-03' = 'Yatırım Hesabı',
  'HT-04' = 'Kredi Hesabı',
  'HT-05' = 'Kredi Kartı Hesabı',
  'HT-06' = 'Çek/Senet Hesabı',
  'HT-07' = 'Kıymetli Maden Hesabı',
  'HT-08' = 'POS Hizmetleri İçin Açılan Hesaplar',
  'HT-09' = 'Ticari Hesap',
  'HT-10' = 'Ticari Hesap',
  'HT-11' = 'Dijital Cüzdan',
  'HT-12' = 'Ödeme Hesabı',
  'HT-13' = 'Elektronik Para Hesabı',
  'HT-14' = 'Ön Ödemeli Araç Hesabı',
  'HT-15' = 'Diğer Ödeme Hizmeti Sağlayıcı Hesabı',
  'HT-99' = 'Mobil Ödeme GSM Hattı',
}

export enum KisitlamaTuruEnum {
  'YK-01' = '5271 SK md 128/Elkoyma',
  'YK-02' = '5549 SK md 19-A/İşlem ertelemesi',
  'YK-03' = '6415 SK',
  'YK-04' = '7262 SK',
  'YK-05' = '2004 SK',
  'YK-06' = '6183 SK',
  'YK-07' = 'Diğer',
}

export enum SupheKategorileriEnum {
  'SK-01' = 'Tefecilik',
  'SK-02' = 'POS Tefeciliği',
  'SK-03' = 'Fuhuşa teşvik veya aracılık etmek',
  'SK-04' = 'Göçmen kaçakçılığı / insan ticareti',
  'SK-05' = 'Uyuşturucu madde ticareti',
  'SK-06' = 'Silah ve mühimmat kaçakçılığı',
  'SK-07' = 'Tarihi eser kaçakçılığı (kültür varlığı ticareti)',
  'SK-08' = 'Gümrük kaçakçılığı / hayali ihracat',
  'SK-09' = 'Kıymetli maden ve taşların kaçakçılığı',
  'SK-10' = 'Bilişim suçları',
  'SK-11' = 'Vergi kaçakçılığı ve vergi kaçırma',
  'SK-12' = 'Sermaye piyasalarına ilişkin suçlar',
  'SK-13' = 'Yolsuzluk ve kamu görevlileriyle ilgili suçlar (rüşvet, irtikap, zimmet, kamu görevlisinin haksız mal edinmesi ve diğer yolsuzluk ve görev suçları)',
  'SK-14' = 'Resmî / özel evrakta sahtecilik',
  'SK-15' = 'Para ve kıymetli evrak dolandırıcılığı/sahteciliği',
  'SK-16' = 'Sigorta dolandırıcılığı/poliçe sahteciliği',
  'SK-17' = 'Dolandırıcılık',
  'SK-18' = 'Organ ve doku ticareti',
  'SK-19' = 'Tehdit/şantaj/cebir ve adam kaçırma',
  'SK-20' = 'Mal varlığına karşı suçlar (hırsızlık, yağma vs.)',
  'SK-21' = 'Hileli iflas',
  'SK-22' = 'Yasa dışı bahis ve kumar oynatma/oynanmasına aracılık etme',
  'SK-23' = 'Terörizmin finansmanı',
  'SK-24' = 'İhaleye fesat karıştırma',
  'SK-25' = 'Sosyal güvenlik mevzuatına aykırılıklar',
  'SK-26' = 'Bankacılık mevzuatına ilişkin suçlar',
  'SK-27' = 'Akaryakıt kaçakçılığı',
  'SK-28' = 'Yasa dışı fatura ödeme merkezi faaliyetleri',
  'SK-29' = 'Lisanssız ödeme ve elektronik para hizmetlerinde bulunma',
  'SK-30' = 'Başkası hesabına işlem yapıldığının beyan edilmemesi',
  'SK-31' = 'Sigara, alkol ve tütün mamulleri kaçakçılığı',
  'SK-32' = 'Piramit satış sistemleri (saadet zincirleri)',
  'SK-33' = 'Sivil toplum kuruluşlarının suiistimali',
  'SK-34' = 'Yasadışı yardım ve bağış toplama',
  'SK-35' = 'Mal varlığının dondurulması kararının ihlali',
  'SK-36' = 'Kitle imha silahlarının yayılmasının finansmanı',
  'SK-37' = 'Yükümlülüklere aykırı hareket edilmesi',
  'SK-38' = 'Müstehcenlik',
  'SK-39' = 'İzinsiz KVHS Faaliyeti',
  'SK-40' = 'Yabancı Kamu Görevlilerine Rüşvet Verilmesi',
  'SK-41' = 'Fiyatları Etkileme',
}

export enum IslemeAracilikEtmeDurumuEnum {
  'AED-01' = 'Banka aracılık etmiştir',
  'AED-02' = 'Banka aracılık etmemiştir',
  'AED-03' = 'Diğer Ödeme Kuruluşu aracılık etmiştir',
}
